import React from "react";

const Footer = () => {
  return (
    <>
      <footer className="mb-0 pt-4 pb-5">
        <div className="container">
          <div className="row align-items-start gy-3">
            <div className="col-md-8 text-start">
              <h5 className="fw-bold mb-3">About Us</h5>
              <p className="mb-3">
                Balvindra Instruments Corporation, founded in 1971, has been a trusted
                name in the scientific instruments industry for more than four decades.
                Guided by a commitment to quality and reliability, we ensure that every
                product meets the highest standards of precision and durability. Serving
                laboratories, research facilities, and educational institutions, our
                diverse range of scientific instruments is designed to empower
                professionals, educators, and researchers with the accuracy and
                consistency they need to excel.
              </p>
            </div>
            <div className="col-md-4 text-md-end text-start">
              <h6 className="fw-bold mb-3">Contact Info</h6>
              <div className="d-flex flex-column gap-2 align-items-md-end align-items-start">
                <div>
                  <i className="fa fa-envelope me-2"></i>
                  <a href="mailto:balco@scientificinstruments.org" className="text-decoration-none text-dark">
                    balco@scientificinstruments.org
                  </a>
                </div>
                <div>
                  <i className="fa fa-phone me-2"></i>
                  <a href="tel:+919896310697" className="text-decoration-none text-dark">+91-9896310697</a>
                </div>
                <div className="d-flex flex-column gap-2 align-items-md-end align-items-start mt-2">
                  <a href="/privacy-policy" className="text-decoration-none text-dark">Privacy Policy</a>
                  <a href="/terms-and-conditions" className="text-decoration-none text-dark">Terms & Conditions</a>
                </div>
              </div>
            </div>
          </div>
          <div className="text-center mt-4">
            <div>© 2025 Balvindra Instruments Corporation</div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
